import { Loader } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export default Loader(({ node }, load) => {
  const { loadTarget } = node.dataset;

  if (!loadTarget) {
    return;
  }

  const targets = loadTarget.split(',');

  targets.forEach((target) => {
    const triggers = Array.from(document.querySelectorAll<HTMLElement>(`[data-load]`)).filter(
      (trigger) =>
        NonNullish(trigger.dataset.load, 'Trigger must have a "data-load" attribute')
          .split(',')
          .includes(target),
    );

    triggers.forEach((element) => {
      const event = element.dataset.event || 'click';

      element.addEventListener(event, load, { passive: true });
    });
  });
});
